import React from 'react';
import { FormSelect, FormGroup, FormFeedback } from 'shards-react';
import { useTranslation } from 'react-i18next';
import './style.css';
const Select = (props) => {
  console.log({props})
  const { inputHasErrors, label } = props;
  const { t, i18n } = useTranslation();
  return (
    <FormGroup>
      {label && <label style={{ textTransform: 'capitalize' }}>{label}</label>}
      <FormSelect className="select-text" invalid={inputHasErrors} {...props}>
        {props.children}
      </FormSelect>
      <FormFeedback invalid>{t(inputHasErrors)}</FormFeedback>
    </FormGroup>
  );
};

export default Select;
